function showModal(modal) {
    if (!modal) {
        return;
    }

    modal.style.display = "block";
    modal.classList.add("show");
    modal.removeAttribute("aria-hidden");

    if (!document.getElementById("modalBackdrop")) {
        const backdrop = document.createElement("div");

        backdrop.className = "modal-backdrop fade show";
        backdrop.id = "modalBackdrop";

        document.body.appendChild(backdrop);
    }

    document.body.classList.add("modal-open");
}

function closeModal(modal) {
    if (!modal) {
        return;
    }

    modal.classList.remove("show");
    modal.style.display = "none";

    const backdrop = document.getElementById("modalBackdrop");

    if (backdrop) {
        backdrop.remove();
    }

    document.body.classList.remove("modal-open");
}

document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("completeProfileModel");

    if (!modal) {
        return;
    }

    showModal(modal);

    const closeButton = modal.querySelector(".btn-close");

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            closeModal(modal);
        });
    }
});
